module.exports = __webpack_public_path__ + "static/media/calendar_l.8a036390.svg";